import { render, staticRenderFns } from "./TrameUploaderItemNew.vue?vue&type=template&id=b3059d30&"
import script from "./TrameUploaderItemNew.vue?vue&type=script&lang=js&"
export * from "./TrameUploaderItemNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports